import { render, staticRenderFns } from "./supplierStockList.vue?vue&type=template&id=713dd928&scoped=true"
import script from "./supplierStockList.vue?vue&type=script&lang=js"
export * from "./supplierStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713dd928",
  null
  
)

export default component.exports